export const statusPaymentConst = {
  waiting: 'waiting',
  completed: 'completed',
};

export const typePaymentConst = {
  auto: 'auto',
  manual: 'manual',
};
